// src/components/Pagination.jsx
import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

const Pagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  onItemsPerPageChange,
  pageSizeOptions = [10, 20, 30, 50]
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  /* Handlers ---------------------------------------------------------------- */
  const handlePrev = useCallback(() => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  }, [currentPage, onPageChange]);

  const handleNext = useCallback(() => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  }, [currentPage, totalPages, onPageChange]);

  const handleItemsPerPage = (e) => {
    const newSize = parseInt(e.target.value, 10);
    onItemsPerPageChange(newSize);
    // Garante página válida
    const newTotalPages = Math.max(1, Math.ceil(totalItems / newSize));
    if (currentPage > newTotalPages) onPageChange(1);
  };

  /* Render ------------------------------------------------------------------ */
  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mt-4 text-sm gap-2">
      {/* Seletor de tamanho --------------------------------------------------- */}
      <div className="flex items-center">
        <label htmlFor="itemsPerPage" className="mr-2">Itens por página:</label>
        <select
          id="itemsPerPage"
          value={itemsPerPage}
          onChange={handleItemsPerPage}
          className="border border-gray-300 rounded-md px-2 py-1"
        >
          {pageSizeOptions.map((size) => (
            <option key={size} value={size}>{size}</option>
          ))}
        </select>
      </div>

      {/* Navegação ------------------------------------------------------------ */}
      {totalItems > 0 ? (
        <div className="flex items-center gap-2">
          <button
            onClick={handlePrev}
            className="custom-button px-3 py-1 rounded-md disabled:opacity-40 disabled:cursor-not-allowed"
            disabled={currentPage === 1}
            aria-label="Página anterior"
          >
            ◄
          </button>

          <span aria-current="page">
            Página {currentPage} de {totalPages}
          </span>

          <button
            onClick={handleNext}
            className="custom-button px-3 py-1 rounded-md disabled:opacity-40 disabled:cursor-not-allowed"
            disabled={currentPage === totalPages}
            aria-label="Próxima página"
          >
            ►
          </button>
        </div>
      ) : (
        <span>Nenhum registro encontrado</span>
      )}
    </div>
  );
};

/* PropTypes ----------------------------------------------------------------- */
Pagination.propTypes = {
  totalItems: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onItemsPerPageChange: PropTypes.func.isRequired,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number)
};

export default memo(Pagination);